import types from '../types';

/**
 * @param {types.Filter} filter
 * @returns {types.Filter}
 */
const getActiveFilter = filter => {
    if (!filter || !filter.options || !filter.options.length) {
        return null;
    }

    const activeItems = filter.options.filter(
        option => option.checked && option.subcategoriesContent
    );

    if (!activeItems.length) {
        return null;
    }

    return {
        ...filter,
        options: activeItems
    };
};

/**
 * @param {types.Filter[]} filters
 * @returns {types.Filter[]}
 */
const getActiveFilterWithSubcategories = filters => {
    if (!filters || !Array.isArray(filters) || !filters.length) {
        return [];
    }

    return filters.map(getActiveFilter).filter(Boolean);
};

export default getActiveFilterWithSubcategories;
